module.exports = __webpack_public_path__ + "img/wx_1.f812d867.png";